export default "__VITE_ASSET__4c7b0468__"